/************************************** THIRD-PARTY MODULES ***************************************/
import React from 'react';
import cn from 'classnames';

/**************************************** PROJECT MODULES *****************************************/
import {translate, WarningModalContent} from '@canimmunize/core-imports';

/********************************************* EXPORT *********************************************/
/**
 * Content of prompt confirming user wants to exit with unsaved changes
 * Wrap with a CIModal to display
 *
 * Run EventHandler function [closeFromExitPrompt] when close clicked, and
 * [returnFromExitPrompt] when back/cancel clicked
 * Optionally display custom warning text by passing in [mainText] string prop
 *
 * @param {Function} closeFromExitPrompt Run when close clicked
 * @param {Function} returnFromExitPrompt Run when back/cancel clicked
 * @param {string} mainText Custom text to replace default text [OPTIONAL]
 */
export const ConfirmExitPrompt = ({
    closeFromExitPrompt,
    returnFromExitPrompt,
    mainText = translate(`warning_unsaved_changes`),
}: {
    closeFromExitPrompt: EventHandler;
    returnFromExitPrompt: EventHandler;
    mainText?: string;
}) => (
    <WarningModalContent
        mainText={mainText}
        handleSubmit={closeFromExitPrompt}
        handleCancel={returnFromExitPrompt}
        contentWrapperStyle={{position: `relative`}}
    />
);
ConfirmExitPrompt.displayName = `ConfirmExitPrompt`;
